export default "__VITE_ASSET__DGVrdye7__"